{
  "documents": {
    "title": "الخزنة الرقمية",
    "subtitle": "إدارة أصولك المؤسساتية والقانونية.",
    "actions": {
      "generate_statutes": "توليد القانون الأساسي",
      "upload": "رفع",
      "view": "عرض",
      "download": "تحميل",
      "share": "مشاركة",
      "delete": "حذف",
      "request_doc": "طلب وثيقة"
    },
    "filters": {
      "all": "كل الوثائق",
      "legal": "قانوني والقانون الأساسي",
      "finance": "الوثائق المالية",
      "tax": "التصريحات الجبائية",
      "hr": "الموارد البشرية",
      "administrative": "إداري"
    },
    "search": "البحث عن وثيقة...",
    "table": {
      "name": "اسم الوثيقة",
      "type": "النوع",
      "date": "تاريخ الإضافة",
      "status": "الحالة",
      "size": "الحجم"
    },
    "status": {
      "verified": "تم التحقق",
      "pending": "قيد التدقيق",
      "draft": "مسودة",
      "expired": "منتهي الصلاحية",
      "archived": "مؤرشف"
    },
    "empty": {
      "title": "لم يتم العثور على وثائق",
      "subtitle": "قم برفع أول وثيقة لك أو قم بتوليد القانون الأساسي للبدء.",
      "cta": "رفع وثيقة"
    },
    "upload": {
      "title": "رفع وثيقة",
      "dropzone": "انقر أو قم بسحب الملف هنا للرفع",
      "hint": "يدعم PDF, JPG, PNG (بحد أقصى 10 ميجابايت)",
      "processing": "جاري تحليل هيكل الوثيقة...",
      "success": "تم رفع الوثيقة وفهرستها بنجاح."
    }
  },
  "common": {
    "not_defined": "غير محدد",
    "not_available": "N/A",
    "previous": "السابق",
    "back": "رجوع",
    "next": "التالي",
    "save": "حفظ",
    "processing": "جاري المعالجة...",
    "saved": "تم الحفظ",
    "export_success": "تم تصدير التقرير بنجاح",
    "currency": "دج",
    "error": {
      "title": "خطأ حرج في النظام",
      "description": "لم يتم تحميل الوحدة بشكل صحيح. التفاصيل التقنية:",
      "reset": "إعادة تعيين الوحدة"
    },
    "link_copied": "تم نسخ الرابط إلى الحافظة",
    "loading": "جاري التحميل...",
    "confirm": "تأكيد",
    "options": {
      "yes": "نعم",
      "no": "لا",
      "confirm": "تأكيد",
      "cancel": "إلغاء",
      "retry": "إعادة المحاولة"
    },
    "new": "جديد",
    "locale": "ar-DZ"
  },
  "dashboard": {
    "title": "إدارة دورة حياة الشركة",
    "subtitle": "تحكم مركزي في التعديلات القانونية والامتثال.",
    "stats": {
      "active_projects": "المشاريع النشطة",
      "compliance_rate": "معدل الامتثال",
      "legal_events": "الأحداث القانونية",
      "next_audit": "التدقيق القادم",
      "legal_form": "الشكل القانوني",
      "capital": "رأس المال الاجتماعي",
      "governance": "الحوكمة",
      "location": "الموقع",
      "active_associates": "الشركاء النشطون",
      "official_identity": "الهوية الرسمية",
      "verified_registry": "تم التحقق لدى السجل التجاري الوطني",
      "tax_status": "الحالة الضريبية G50 محينة",
      "legal_status": "القانون الأساسي مصادق عليه",
      "title": "نظرة على البيانات",
      "age": "عمر الشركة",
      "years": "{{count}} سنوات",
      "established": "مستقرة",
      "secure": "آمنة",
      "no_manager": "لا يوجد مسير",
      "compliance": "الامتثال"
    },
    "grid": {
      "simulator": {
        "title": "محاكي الجباية والضمان الاجتماعي",
        "desc": "محاكاة وتحسين هيكل شركتك قبل الإطلاق."
      },
      "name_check": {
        "title": "التحقق من العلامة التجارية",
        "desc": "التحقق من توفر الاسم ومخاطر النزاعات القانونية."
      },
      "create": {
        "title": "إنشاء شركة",
        "desc": "مسار موحد للإجراءات الإدارية والقانونية."
      },
      "documents": {
        "title": "الخزنة المؤسساتية",
        "desc": "الوصول وإدارة جميع وثائقك الرسمية."
      }
    },
    "journal": {
      "title": "سجل العمليات",
      "empty": "لا توجد أحداث مسجلة"
    },
    "actions": {
      "search_placeholder": "البحث عن إجراء قانوني...",
      "download_dossier": "الملف الرقمي للشركة (PDF)",
      "hq_transfer": {
        "title": "تحويل المقر",
        "desc": "تغيير رسمي للعنوان القانوني."
      },
      "capital_update": {
        "title": "تغيير رأس المال",
        "desc": "زيادة أو تخفيض رأس المال الاجتماعي."
      },
      "form_change": {
        "title": "تغيير الشكل القانوني",
        "desc": "التحويل إلى SARL، SPA أو EURL."
      },
      "manager_update": {
        "title": "تعيين مسير",
        "desc": "تغيير أو تجديد الإدارة."
      },
      "dissolution": {
        "title": "حل الشركة",
        "desc": "قرار رسمي بوقف النشاط."
      },
      "liquidation": {
        "title": "الشطب والتصفية",
        "desc": "الإغلاق النهائي والشطب."
      },
      "associates": {
        "title": "إدارة الشركاء",
        "desc": "تحديث المساهمات ودخول شركاء."
      },
      "object": {
        "title": "الغرض الاجتماعي",
        "desc": "تعديل نشاطات المؤسسة."
      },
      "cnrc_portal": "بوابة CNRC"
    },
    "legal": {
      "title": "العمليات القانونية"
    },
    "vault": {
      "title": "الخزنة الرقمية"
    },
    "toasts": {
      "titles": {
        "success": "نجاح",
        "error": "خطأ",
        "info": "معلومات",
        "warning": "تحذير"
      },
      "generating_pdf": "جاري مزامنة البيانات وتوليد ملف PDF...",
      "pdf_success": "تم تصدير الملف القانوني بنجاح.",
      "pdf_error": "فشل توليد الملف الرقمي.",
      "hq_transfer_success": "تم تسجيل تحويل المقر.",
      "capital_update_success": "تم تأكيد تغيير رأس المال.",
      "form_change_success": "تم تحديث الشكل القانوني بنجاح.",
      "manager_update_success": "تم تسجيل تعيين المسير.",
      "dissolution_success": "تم توليد عقد الحل.",
      "liquidation_success": "اكتملت عملية التصفية.",
      "associates_success": "تم تحديث سجل الشركاء.",
      "object_success": "تم تسجيل تعديل الغرض الاجتماعي.",
      "action_error": "حدث خطأ أثناء المعالجة.",
      "load_failed": "تعذر مزامنة بيانات الشركة.",
      "wizard_success": "تم تسجيل الإجراء القانوني وتحديث السجل.",
      "wizard_error": "حدث خطأ أثناء تنفيذ الإجراء."
    },
    "pdf": {
      "title": "الملف القانوني للشركة",
      "date": "التاريخ",
      "ref": "المرجع",
      "sections": {
        "identity": "1. هوية الشركة",
        "governance": "2. الحوكمة والهيكل",
        "history": "تاريخ العمليات القانونية"
      },
      "table": {
        "field": "الحقل",
        "info": "المعلومات",
        "role": "الدور",
        "entity_person": "الكيان/الشخص",
        "status": "الحالة",
        "date": "التاريخ",
        "action_type": "نوع العملية",
        "summary": "الملخص"
      },
      "fields": {
        "legal_name": "الاسم القانوني",
        "legal_form": "الشكل القانوني",
        "nif": "رقم التعريف الجبائي (NIF)",
        "rc": "السجل التجاري",
        "capital": "رأس المال",
        "headquarters": "المقر الاجتماعي",
        "manager": "المسير",
        "active": "نشط",
        "associates": "الشركاء",
        "members": "{{count}} أعضاء",
        "registered": "مسجل"
      },
      "defaults": {
        "modification": "تعديل قانوني",
        "ledger": "عملية مسجلة في سجل الشركة."
      },
      "filename_suffix": "ملف_الشركة"
    },
    "events": {
      "title": "مركز العمليات",
      "journal": "اليومية",
      "view_all": "عرض الكل",
      "no_history": "لا يوجد سجل متاح",
      "types": {
        "compliance": "الامتثال",
        "tax": "الجباية",
        "security": "الأمن",
        "creation": "التسجيل الأولي",
        "capital_increase": "زيادة رأس المال",
        "headquarters_transfer": "تحويل المقر",
        "legal_form_change": "تغيير الشكل",
        "partner_addition": "إضافة شريك",
        "manager_update": "تغيير المسير",
        "associates_update": "تحديث الشركاء",
        "dissolution": "قرار الحل",
        "liquidation_started": "بدء التصفية",
        "liquidation_completed": "تأكيد الشطب",
        "certificate_generation": "إصدار وثيقة"
      },
      "descriptions": {
        "creation": "التسجيل الأولي للشركة.",
        "capital_increase": "رأس المال: {{amount}} دج",
        "headquarters_transfer": "المقر الاجتماعي: {{address}}",
        "legal_form_change": "الشكل: {{form}}",
        "partner_addition": "شريك جديد: {{name}}",
        "manager_update": "مسير جديد: {{name}}",
        "associates_update": "تحديث هيكل المساهمة ({{count}} شركاء).",
        "dissolution": "قرار حل الشركة.",
        "liquidation_started": "دخول الشركة في مرحلة التصفية.",
        "liquidation_completed": "تأكيد شطب السجل التجاري.",
        "certificate_generation": "إصدار شهادة رسمية."
      },
      "statuses": {
        "completed": "مكتمل",
        "pending": "قيد الانتظار",
        "draft": "مسودة",
        "active": "نشط",
        "archived": "مؤرشف"
      }
    },
    "loading": {
      "engine": "مزامنة المحرك القانوني..."
    },
    "statuses": {
      "liquidation": "تصفية",
      "dissolved": "منحلة",
      "active": "نشطة"
    },
    "empty_state": {
      "title": "لم يتم اكتشاف كيان قانوني",
      "description": "يجب أن تملك شركة نشطة للوصول إلى <1>مدير الدورة القانونية</1>.",
      "cta": "تسجيل شركة"
    },
    "wizard": {
      "steps": {
        "structure": "الهيكل ورأس المال",
        "review": "المراجعة والتصديق",
        "execution": "التأكيد والتنفيذ"
      },
      "messages": {
        "finalizing": "جاري إنهاء الإجراء وتحديث السجل..."
      },
      "fields": {
        "configuration": "تهيئة الإجراء",
        "new_address": "العنوان القانوني الجديد",
        "address": "العنوان",
        "address_placeholder": "أدخل العنوان الكامل",
        "wilaya": "المدينة / الولاية",
        "wilaya_placeholder": "الجزائر",
        "type": "النوع",
        "lease": "عقد إيجار تجاري",
        "property": "ملكية",
        "new_capital": "رأس المال الاجتماعي الجديد (دج)",
        "new_form": "الشكل القانوني الجديد",
        "new_manager": "اسم المسير الجديد",
        "capital_placeholder": "مثال: 1,000,000",
        "current": "الحالي",
        "fullname": "الاسم الكامل",
        "fullname_placeholder": "الاسم واللقب",
        "shares": "الحصص (%)",
        "shares_placeholder": "25",
        "role": "الدور",
        "associate": "شريك",
        "manager": "مسير",
        "director_general": "مدير عام",
        "default_reason": "قرار إجماعي من الشركاء",
        "default_wilaya": "الجزائر",
        "legal_form_desc": {
          "SARL": "شركاء متعددون",
          "EURL": "شريك وحيد",
          "SPA": "مؤسساتي",
          "SAS": "مرن"
        }
      },
      "warnings": {
        "critical_action": "إجراء حرج",
        "irrevocable": "هذا الإجراء غير قابل للتراجع وسيتم تسجيله في اليومية الرسمية.",
        "irreversible": "إجراء غير قابل للعكس",
        "irreversible_desc": "سيؤدي هذا الإجراء إلى إنهاء نشاط الشركة بشكل دائم."
      },
      "placeholders": {
        "generic_config": "لا يلزم تهيئة محددة لهذا التصرف.",
        "no_changes": "لم يتم اكتشاف أي تغييرات في التهيئة الحالية."
      },
      "buttons": {
        "confirm_understanding": "أفهم وأؤكد",
        "confirmed": "تم التأكيد",
        "processing": "جاري المعالجة...",
        "finish": "إنهاء وحفظ"
      },
      "validation": {
        "statutory": "الامتثال القانوني",
        "cnrc": "السجل التجاري (CNRC)",
        "tax": "الأهلية الضريبية",
        "valid": "صالح",
        "compliant": "ممتثل",
        "ready": "جاهز",
        "ready_signature": "جاهز للتوقيع",
        "no_blockage": "لم يتم اكتشاف أي عائق قانوني."
      },
      "execution": {
        "title": "التأكيد والتنفيذ",
        "desc": "تحديث البيانات وتوليد الشهادات."
      },
      "errors": {
        "address_required": "العنوان الدقيق مطلوب",
        "capital_invalid": "مبلغ رأس المال غير صالح",
        "form_required": "يرجى اختيار شكل قانوني صالح",
        "name_required": "اسم الشريك مطلوب",
        "confirm_dissolution": "يرجى تأكيد قرار الحل",
        "confirm_liquidation": "يرجى تأكيد إغلاق التصفية"
      },
      "toasts": {
        "recorded_title": "تم تسجيل الإجراء",
        "recorded_msg": "تم تسجيل التعديل في سجل الشركة.",
        "failed_title": "فشل التدقيق",
        "missing_field": "حقل مفقود"
      }
    },
    "dossier_pdf": {
      "title": "ملف الشركة الرقمي",
      "generated_at": "تم التوليد في {{date}}",
      "identity": {
        "title": "1. هوية الشركة",
        "name": "التسمية:",
        "legal_form": "الشكل القانوني:",
        "capital": "رأس المال الاجتماعي:",
        "hq": "المقر الاجتماعي:",
        "unspecified": "غير محدد"
      },
      "governance": {
        "title": "2. الحوكمة والشركاء",
        "header_name": "الاسم",
        "header_role": "الدور",
        "header_shares": "الحصص",
        "header_contribution": "المساهمة",
        "role_manager": "مسير",
        "role_gm": "مدير عام",
        "role_partner": "شريك",
        "empty": "لا يوجد شركاء مسجلين"
      }
    },
    "errors": {
      "address_required": "L'adresse exacte est requise",
      "capital_invalid": "Montant du capital invalide",
      "form_required": "Sélectionnez une forme juridique valide",
      "name_required": "Nom de l'associé requis",
      "confirm_dissolution": "Veuillez confirmer la décision de dissolution",
      "confirm_liquidation": "Veuillez confirmer la clôture de liquidation"
    }
  },
  "simulator": {
    "structures": {
      "EURL": {
        "label": "EURL",
        "description": "مؤسسة ذات مسؤولية محدودة ذات شخص وحيد"
      },
      "SARL": {
        "label": "SARL",
        "description": "شركة ذات مسؤولية محدودة"
      },
      "SPA": {
        "label": "SPA",
        "description": "شركة مساهمة"
      },
      "SAS": {
        "label": "SAS",
        "description": "شركة أسهم مبسطة"
      },
      "SNC": {
        "label": "SNC",
        "description": "شركة التضامن"
      },
      "INDIVIDUELLE": {
        "label": "مؤسسة فردية",
        "description": "نشاط فردي بدون شخصية معنوية"
      }
    },
    "title": "محاكي الجباية والضمان الاجتماعي",
    "subtitle": "قم بتهيئة هيكلك في 4 خطوات بسيطة.",
    "steps": {
      "project": "مشروعك",
      "project_desc": "لنبدأ بأساسيات نشاطك القادم.",
      "structure": "الهيكل ورأس المال",
      "structure_desc": "حدد حجم وموارد كيانك.",
      "vision": "الرؤية والمخاطر",
      "vision_desc": "تحسين الأهداف الاستراتيجية للمحاكاة.",
      "ready": "التهيئة جاهزة",
      "ready_desc": "تحقق من إعداداتك قبل تشغيل التحكيم."
    },
    "fields": {
      "activity_sector": "قطاع النشاط",
      "simulation_mode": "وضع المحاكاة",
      "partners": "عدد الشركاء",
      "partner_label": "شريك",
      "partners_label": "شركاء",
      "capital": "رأس المال الأولي (دج)",
      "objective": "الهدف الرئيسي",
      "risk": "المخاطر المقدرة",
      "investors": "مستثمرون؟",
      "currency": "دج"
    },
    "options": {
      "services": "خدمات",
      "commerce": "تجارة",
      "industry": "صناعة",
      "artisanat": "حرف",
      "startup": "تكنولوجيا / شركة ناشئة",
      "standard": "قياسي (قانوني)",
      "premium": "ممتاز (قريباً)",
      "growth": "نمو سريع",
      "growth_desc": "التركيز على التوسع والحصة السوقية",
      "stability": "الأمن والاستقرار",
      "stability_desc": "أقصى حماية للأصول",
      "tax_optimization": "التحسين الضريبي",
      "tax_optimization_desc": "تقليل العبء الضريبي",
      "low": "منخفض",
      "medium": "متوسط",
      "high": "عالٍ",
      "yes": "نعم",
      "no": "لا"
    },
    "summary": {
      "activity": "النشاط",
      "partners": "الشركاء",
      "capital": "رأس المال الأولي",
      "priority": "الأولوية"
    },
    "buttons": {
      "reset": "إعادة تعيين",
      "calculate": "حساب المؤشرات",
      "previous": "السابق",
      "continue": "متابعة",
      "run": "بدء المحاكاة",
      "executing": "جاري التنفيذ..."
    },
    "footer": {
      "certification": "نظام دعم القرار بالذكاء الاصطناعي — معتمد DZ_LAW_2025"
    },
    "info": "من خلال تشغيل هذه المحاكاة، سيقوم محركنا بمعالجة أكثر من 150 متغيرًا قانونيًا بناءً على القانون التجاري الجزائري لاقتراح الهيكل الأمثل.",
    "engine": {
      "forms": {
        "EURL": {
          "name": "EURL",
          "desc": "شركة الشخص الواحد. مثالية للمؤسسين المنفردين الذين يرغبون في مسؤولية محدودة."
        },
        "SARL": {
          "name": "SARL",
          "desc": "شركة ذات مسؤولية محدودة. المعيار للعديد من الشركاء مع حماية الأصول."
        },
        "SPA": {
          "name": "SPA",
          "desc": "شركة مساهمة. مصممة لرؤوس الأموال الكبيرة والمستثمرين الخارجيين."
        },
        "SAS": {
          "name": "SAS",
          "desc": "شركة أسهم مبسطة. حوكمة مرنة، رائعة للشركات الناشئة."
        },
        "SNC": {
          "name": "SNC",
          "desc": "شركة تضامن. مسؤولية تضامنية غير محدودة، مناسبة للشركات العائلية ذات الثقة العالية."
        },
        "INDIVIDUELLE": {
          "name": "مؤسسة فردية",
          "desc": "إعداد بسيط، ولكن مع مسؤولية شخصية غير محدودة."
        }
      },
      "reasons": {
        "partners_min": "عدد الشركاء أقل من الحد الأدنى القانوني.",
        "partners_max": "عدد الشركاء يتجاوز الحد الأقصى القانوني.",
        "capital_min": "رأس المال أقل من الحد الأدنى القانوني المطلوب.",
        "capital_ok": "رأس المال الاجتماعي يتوافق مع المتطلبات القانونية.",
        "risk_limited": "المسؤولية المحدودة مثالية لرغبتك في المخاطرة.",
        "risk_unlimited": "مسؤولية غير محدودة: مخاطر عالية على أصولك الشخصية.",
        "risk_incompatible": "مخاطر عالية: أصولك الشخصية غير محمية.",
        "investor_ready": "القدرة على استقبال مستثمرين مؤسساتيين.",
        "investor_unready": "هيكل غير مناسب للمستثمرين الخارجيين.",
        "partners_ok": "عدد الشركاء ممتثل.",
        "protected_assets": "أصولك الشخصية محمية قانوناً.",
        "startup_framework": "إطار قانوني مصمم خصيصاً للشركات الناشئة المعتمدة.",
        "partners_1": "هيكل محسن لمؤسس واحد.",
        "partners_multi": "حوكمة مصممة لشركاء متعددين.",
        "partners_spa_min": "يستوفي شرط الحد الأدنى لـ 7 شركاء في شركة مساهمة.",
        "capital_1m": "رأس المال يستوفي العتبة المؤسساتية (> 1 مليون دج).",
        "capital_100k": "رأس مال قياسي لشركة ذات مسؤولية محدودة (> 100 ألف دج).",
        "tax_opt": "نظام ضريبي محسن لهذا القطاع من النشاط.",
        "asset_shield": "فصل قانوني كامل بين الأصول الشخصية والمهنية.",
        "investor_fit": "هيكل ملكية قابل للتوسع لجمع التبرعات الخارجية.",
        "growth_engine": "حوكمة مرنة تدعم التوسع السريع.",
        "governance_flex": "قيود إدارية منخفضة للإدارة اليومية."
      },
      "explanations": {
        "DEFAULT": "هيكل غير مناسب تماماً لمشروعك الحالي.",
        "EURL_SINGLE_PARTNER": "خيار أمثل لشريك وحيد يرغب في تحديد مسؤوليته في حدود رأس المال.",
        "EURL_RECOMMENDED": "موصى به: توفر EURL حماية مهنية لمشروعك المنفرد.",
        "INDIVIDUELLE_SINGLE_PARTNER": "أكثر هيكل مرونة للمقاول المنفرد، بدون حد أدنى قانوني صارم لرأس المال.",
        "INDIVIDUELLE_RECOMMENDED": "بسيط ومباشر، مثالي للمؤسسات المصغرة.",
        "SARL_PME": "الهيكل المعياري للمؤسسات الصغيرة والمتوسطة في الجزائر، يوفر توازناً بين التكلفة والحماية.",
        "SARL_RECOMMENDED": "موصى به: توازن SARL بشكل مثالي بين الحماية القانونية والمرونة لمشروعك.",
        "SARL_VIABLE": "خيار قابل للتطبيق، ولكنه قد يكون أقل تحسيناً من الخيار الأولي لملفك.",
        "SAS_STARTUP": "مثالي لشركة ناشئة: حرية تعاقدية كاملة وجاذبية للمستثمرين.",
        "SAS_SINGLE_PARTNER": "مثالي لمؤسس شركة ناشئة منفرد: حرية تعاقدية كاملة.",
        "SAS_RECOMMENDED": "حديث ومرن، مثالي للابتكار والتوسع.",
        "SPA_LARGE": "مصمم للمشاريع الكبيرة مع دعوة الجمهور للادخار أو رؤوس الأموال الضخمة.",
        "SPA_RECOMMENDED": "إطار مؤسساتي للمشاريع ذات النمو العالي أو رأس المال الكبير.",
        "SNC_TRUST": "هيكل قائم على الثقة، مناسب للمشاريع العائلية أو الحرفية.",
        "SNC_RECOMMENDED": "هيكل بسيط قائم على الثقة المتبادلة بين الشركاء.",
        "SCS_HYBRID": "هيكل هجين يسمح بالفصل بين المسيرين والممولين.",
        "SCS_RECOMMENDED": "يسمح بوجود مستثمرين سلبيين مع الاحتفاظ بالسيطرة على الإدارة.",
        "EURL_SOLO": "EURL هو المركبة الأكثر أماناً للمقاولين المنفردين. تسمح بالتحكم الكامل مع حماية الثروة الشخصية.",
        "SARL_STANDARD": "تظل SARL العمود الفقري للاقتصاد الجزائري. توفر إطاراً قوياً للشراكات والمؤسسات الصغيرة والمتوسطة.",
        "SPA_INSTITUTIONAL": "مصممة للعمليات الكبيرة، توفر SPA الشفافية والهيكل اللازم لرأس المال المؤسساتي.",
        "SNC_PARTNERSHIP": "تعتمد SNC على 'الاعتبار الشخصي' (ثقة قوية بين الشركاء)، وتوفر إطاراً مبسطاً ولكن بضمانات قوية.",
        "SARL_TAX_EFFICIENT": "تسمح هذه التهيئة بتوازن محسن بين ضرائب الشركات وتوزيع الأرباح.",
        "EURL_PROTECTION": "اختيار EURL يضمن بقاء المخاطر المهنية ضمن حدود رأس مال الشركة.",
        "SPA_INVESTOR": "طبيعة الأسهم في هذا الكيان مناسبة تماماً لجدول المساهمين المعقد والخروج المستقبلي."
      },
      "warnings": {
        "min_partners": "الحد الأدنى للشركاء المطلوب: {{value}}.",
        "max_partners": "تجاوز الحد الأقصى للشركاء (الحد: {{value}}).",
        "low_capital_amount": "رأس المال أقل من الحد الأدنى القانوني ({{value}} دج).",
        "high_turnover": "مخاطر رقم الأعمال: لا ينصح بالهيكل الفردي للحجم الكبير.",
        "high_risk": "حرج: الأصول الشخصية معرضة لديون الشركة.",
        "no_investors": "عائق: هذا الهيكل يمنع دخول رأس المال الاستثماري."
      },
      "liability": {
        "limited": "محدودة",
        "unlimited": "غير محدودة",
        "limited_to_shares": "محدودة في حدود الحصص"
      },
      "risk_status": {
        "low": "مؤمن",
        "medium": "متوسط",
        "high": "حرج"
      },
      "default_justification": "يوفر هذا الهيكل أفضل توازن بين الحماية والتكلفة."
    },
    "result": {
      "title": "نتيجة المحاكاة",
      "subtitle": "تحليل مفصل وتوصيات قانونية بناءً على مدخلاتك.",
      "share": {
        "title": "محاكاة الهيكل القانوني - شريكاتي",
        "text": "اكتشف تحكيمي القانوني المولد بواسطة شريكاتي.",
        "success": "تم نسخ رابط المحاكاة إلى الحافظة",
        "error": "فشلت المشاركة"
      },
      "badge_ai": "مدعوم بالذكاء الاصطناعي",
      "pdf": {
        "generating": "جاري التوليد...",
        "download": "تحميل تقرير PDF",
        "header_subtitle": "محرك التحكيم القانوني v2.4",
        "reference": "المرجع: #{{ref}}",
        "date": "التاريخ: {{date}}",
        "main_title": "تقرير القرار",
        "param_header": "المعلمة",
        "value_header": "القيمة المدخلة",
        "section1_title": "1. ملخص تنفيذي",
        "summary_text": "بناءً على التحليل الخوارزمي لمعلماتك، الهيكل الموصى به هو {{fullName}} ({{name}}).",
        "match_score": "معدل المطابقة: {{score}}%",
        "tax_regime": "النظام الضريبي: {{regime}}",
        "section2_title": "2. معلمات المحاكاة",
        "param_partners": "عدد الشركاء",
        "param_capital": "رأس المال الاجتماعي",
        "param_activity": "نوع النشاط",
        "param_risk": "مستوى المخاطر",
        "param_objective": "الهدف الاستراتيجي",
        "param_investors": "فتح رأس المال",
        "risk_high": "عالٍ",
        "risk_medium": "متوسط",
        "risk_low": "منخفض",
        "yes": "نعم",
        "no": "لا",
        "section3_title": "3. التحليل المقارن والمزايا",
        "pros_title": "مزايا الهيكل:",
        "footer": "صفحة {{page}} من {{total}} - وثيقة مولدة بواسطة نظام شريكاتي GSD",
        "error": "فشل إنشاء PDF"
      },
      "optimal_arbitrage": "التحكيم الأمثل",
      "status": "الحالة: {{status}}",
      "optimal_description": "{{fullName}}. هذا الهيكل هو الأكثر ملاءمة لرأس مال قدره {{capital}} دج مع {{partners}} شريك.",
      "strategic_match": "المطابقة الاستراتيجية",
      "tax_regime": "النظام الضريبي",
      "liability": "المسؤولية",
      "risk_analysis": "تحليل المخاطر",
      "risk_evaluation": "تقييم الامتثال والتعرض",
      "no_blocking_points": "لم يتم تحديد أي نقاط منع رئيسية.",
      "complexity_index": "مؤشر التعقيد",
      "viability_score": "درجة الجدوى",
      "viability_trend": "+12% مقابل البدائل",
      "asset_protection": "حماية الأصول",
      "protection_max": "قصوى",
      "protection_partial": "جزئية",
      "capital_flexibility": "مرونة رأس المال",
      "flexibility_total": "كاملة",
      "flexibility_medium": "متوسطة",
      "scale_potential": "إمكانية التوسع",
      "scale_high": "عالية",
      "scale_medium": "متوسطة",
      "legal_interpretation": "التفسير القانوني",
      "legal_intro": "وفقاً لأحكام القانون التجاري الجزائري، فإن اختيارك لـ {{name}} يسمح بمسؤولية {{liability}}. {{justification}}",
      "strengths": "نقاط القوة (Alpha)",
      "weaknesses": "القيود والحدود",
      "recommended_actions": "الإجراءات الموصى بها",
      "implementation_roadmap": "خارطة طريق التنفيذ",
      "roadmap": {
        "step1_title": "القانون الأساسي الموثق",
        "step1_desc": "صياغة القانون الأساسي مع ذكر دقيق للغرض الاجتماعي.",
        "step2_title": "إيداع رأس المال",
        "step2_desc": "فتح حساب 'شركة قيد التأسيس' لتجميد رأس المال.",
        "step3_title": "التسجيل في CNRC",
        "step3_desc": "المباشرة في إجراءات التسجيل خلال 30 يوماً."
      },
      "start_constitution": "بدء التأسيس",
      "new_simulation": "محاكاة جديدة",
      "algorithmic_confidence": "الثقة الخوارزمية",
      "engine_certified": "محرك معتمد v2.4",
      "print_report": "طباعة التقرير",
      "benchmarks": "المقارنات المرجعية",
      "benchmarks_description": "تحليل مقارن مع الهياكل الأخرى",
      "match": "مطابقة",
      "arbitrage_details": "تفاصيل التحكيم"
    },
    "forms": {
      "EURL": {
        "name": "EURL",
        "fullName": "مؤسسة ذات مسؤولية محدودة ذات شخص وحيد",
        "description": "الهيكل الأول للمقاولين المنفردين الراغبين في حماية أصولهم الشخصية.",
        "taxRegime": "خيار IRG أو IBS",
        "pros": [
          "حماية كاملة للأصول الشخصية",
          "سهولة التحول إلى SARL عند انضمام شركاء",
          "خيار النظام الضريبي (IBS ممكن)"
        ],
        "cons": [
          "شكلية إدارية (قانون أساسي، موثق، CNRC)",
          "التزامات محاسبية كاملة",
          "تكلفة إعداد عالية (موثق + BOAL)"
        ]
      },
      "SARL": {
        "name": "SARL",
        "fullName": "شركة ذات مسؤولية محدودة",
        "description": "مثالية للمؤسسات الصغيرة والمتوسطة العائلية والارتباطات من 2 إلى 50 شخصاً.",
        "taxRegime": "IBS",
        "pros": [
          "أقصى أمان قانوني للشركاء",
          "هيكل معروف جداً لدى البنوك الجزائرية",
          "نقل حصص محكم (يحافظ على الطابع العائلي)"
        ],
        "cons": [
          "دخول مستثمرين جدد معقد (يتطلب موافقة)",
          "سقف محدد بـ 50 شريكاً",
          "المسير مسؤول في حالة خطأ في التسيير"
        ]
      },
      "SPA": {
        "name": "SPA",
        "fullName": "شركة مساهمة",
        "description": "هيكل التميز للشركات الكبيرة ومشاريع رأس المال الضخمة.",
        "taxRegime": "IBS",
        "pros": [
          "مصداقية قصوى مع كبار العملاء/الدولة",
          "نقل أسهم حر وفوري",
          "إمكانية الدخول إلى بورصة الجزائر"
        ],
        "cons": [
          "رأس مال أدنى 1,000,000 دج إلزامي",
          "حوكمة ثقيلة (مجلس إدارة)",
          "محافظ حسابات إلزامي عند التأسيس"
        ]
      },
      "SAS": {
        "name": "SAS",
        "fullName": "شركة أسهم مبسطة",
        "description": "شكل مرن جديد مخصص للشركات الناشئة المعتمدة في الجزائر.",
        "taxRegime": "IBS (إعفاءات ممكنة للشركات الناشئة)",
        "pros": [
          "حرية تعاقدية كاملة للقوانين الأساسية",
          "مثالية لعمليات جمع الأموال المتتالية",
          "يمكن دمجها مع علامة شركة ناشئة (مزايا ضريبية)"
        ],
        "cons": [
          "محجوزة للمقاولين المبتكرين أو الشركات المعتمدة",
          "تتطلب صياغة دقيقة جداً للقوانين الأساسية",
          "هيكل لا يزال 'فتياً' بالنسبة لبعض البنوك المحلية"
        ]
      },
      "SNC": {
        "name": "SNC",
        "fullName": "شركة التضامن",
        "description": "شراكة قائمة على الثقة المتبادلة المطلقة.",
        "taxRegime": "IRG (شفافية ضريبية)",
        "pros": [
          "لا يوجد رأس مال أدنى حقيقي مطلوب",
          "لا يوجد التزام بنشر الحسابات السنوية",
          "صورة قوية للتضامن تجاه الدائنين"
        ],
        "cons": [
          "مسؤولية غير محدودة وتضامنية على الأصول الشخصية",
          "أقصى خطر: إذا أفلس شريك واحد، الجميع يدفع",
          "صعوبة الخروج من الشركة بدون اتفاق إجماعي"
        ]
      },
      "INDIVIDUELLE": {
        "name": "مؤسسة فردية / عمل حر",
        "fullName": "مؤسسة فردية (شخص طبيعي)",
        "description": "البساطة الإدارية المطلقة للبدء بمفردك.",
        "taxRegime": "IFU (الضريبة الجزافية الوحيدة)",
        "pros": [
          "إنشاء فوري لدى CNRC (بطاقة فقط)",
          "تكلفة تسيير تقارب الصفر",
          "محاسبة مبسطة للغاية"
        ],
        "cons": [
          "اختلاط الأصول الشخصية والمهنية",
          "مستحيل وجود شركاء لاحقاً",
          "مصداقية محدودة للعقود الكبيرة"
        ]
      }
    }
  },
  "name_check": {
    "title": "التحقق من العلامة التجارية",
    "subtitle": "تحليل مقارن متعدد النواقل لتأمين هويتك التجارية.",
    "brand_arbitrage": "تحكيم العلامة التجارية",
    "description": "نظام خبير للتحقق من التوفر وتحليل مخاطر الالتباس القانوني وفقاً لمعايير السجل التجاري الكويتي (أو الجزائري حسب السياق).",
    "multi_layer_audit": "تدقيق متعدد الطبقات",
    "check_1": "التوفر في السجل المركزي",
    "check_2": "التشابه الصوتي والبصري",
    "check_3": "المطابقة اللغوية (عربي/فرنسي)",
    "check_4": "تحليل حماية العلامة",
    "step1_label": "التسمية المطلوبة",
    "name_placeholder": "مثال: حلول الجزائر التكنولوجية",
    "step2_label": "قطاع النشاط",
    "sectors": {
      "tech": "التكنولوجيا والرقمنة",
      "telecom": "الاتصالات",
      "finance": "البنوك والمالية",
      "industry": "الصناعة والطاقة",
      "construction": "البناء والأشغال العمومية",
      "services": "الخدمات للشركات",
      "health": "الصحة والصيدلة",
      "trade": "التجارة والتوزيع",
      "agro": "الصناعات الغذائية",
      "other": "قطاعات أخرى"
    },
    "step3_label": "تفاصيل المشروع (اختياري)",
    "details_placeholder": "صف النشاط باختصار لتحسين تحليل المخاطر...",
    "analyze_button": "إطلاق تدقيق LegalEngine",
    "checking": "جاري التدقيق...",
    "database_info": "قاعدة بيانات متزامنة مع السجل التجاري",
    "compliance_guarantee": "مراقبة الامتثال مضمونة",
    "connected_to": "متصل بـ",
    "central_registry": "السجل التجاري المركزي",
    "errors": {
      "reserved": "هذا الاسم محجوز حالياً في جلستك النشطة."
    },
    "engine": {
      "explanation": {
        "unavailable": "هذا الاسم به تعارض مباشر أو تشابه حرج مع كيان موجود في السجل التجاري.",
        "risky": "الاسم متاح ولكن يظهر مخاطر تشابه متوسطة. ينصح بتعديل طفيف.",
        "available": "توفر ممتاز. لم يتم اكتشاف أي تعارض رئيسي في القطاع المختار."
      }
    },
    "results": {
      "title": "نتائج التحليل",
      "availability": "التوفر",
      "risk_level": "مستوى المخاطر",
      "recommendation": "التوصية",
      "risk_levels": {
        "low": "مخاطر منخفضة",
        "medium": "مخاطر متوسطة",
        "high": "مخاطر عالية"
      },
      "distinctiveness_levels": {
        "high": "تمايز عالي",
        "low": "تمايز منخفض"
      },
      "metrics": {
        "phonetic": "صوتي",
        "phonetic_value": "{{percent}}% تطابق",
        "visual": "بصري",
        "visual_value": "{{percent}}% تطابق"
      },
      "recommendations": {
        "ACCEPT": "قبول",
        "MODIFY": "تعديل",
        "REJECT": "رفض"
      }
    }
  },
  "name_result": {
    "title": "تقرير تدقيق Sentinel",
    "subtitle": "تحليل الأهلية وحماية العلامة التجارية.",
    "status_valid": "صالح / متاح",
    "status_invalid": "غير متاح / مخاطر",
    "compiling": "جاري تجميع التحليل...",
    "recommended_action": "الإجراء الموصى به",
    "digital_assets": "الأصول الرقمية والنطاقات",
    "footer_advisory": "تم إنشاء هذا التقرير لأغراض إعلامية بواسطة LegalEngine ولا يحل محل الشهادة الرسمية من السجل التجاري (CNRC).",
    "summary": {
      "title": "ملخص التدقيق",
      "subtitle": "تحليل لغوي وقانوني عميق",
      "legal_risk": "المخاطر القانونية",
      "phonetic": "تعارض صوتي",
      "visual": "تعارض بصري",
      "metric": "المقياس",
      "score": "النتيجة",
      "description": "الوصف",
      "class": "الفئة",
      "sector": "القطاع",
      "distinctiveness": "Force Distinctive"
    },
    "conflicts": {
      "title": "تحليل التعارض",
      "entity": "الكيان",
      "similarity": "التشابه",
      "sector": "القطاع",
      "registered": "مسجل في السجل التجاري",
      "match": "تطابق"
    },
    "decision": {
      "title": "قرار Sentinel"
    },
    "domains": {
      "free": "حر / متاح",
      "taken": "محجوز",
      "global_asset": "أصل عالمي"
    },
    "actions": {
      "new_search": "بحث جديد",
      "reserve": "حجز هذا الاسم",
      "excel": "تدقيق إكسيل",
      "pdf": "تقرير PDF",
      "download_pdf": "Télécharger Rapport PDF",
      "download_excel": "Exporter Données"
    },
    "metrics": {
      "memorability": "قابلية التذكر",
      "memorability_desc": "قدرة الجمهور على تذكر الاسم.",
      "protection": "مؤشر الحماية",
      "protection_desc": "سهولة الدفاع القانوني عن العلامة.",
      "availability": "التوفر الفوري",
      "availability_desc": "الحالة الحالية في السجل الوطني."
    },
    "similarity": "التشابه",
    "engine_status": "Sentinel v4.2 • LegalEngine نشط",
    "analysis": {
      "title": "Analyse Détaillée Sentinel",
      "description": "Notre moteur d'IA analyse le nom proposé par rapport aux registres du commerce et marques déposées."
    },
    "toasts": {
      "reserve_success_title": "Nom Réservé",
      "reserve_success_msg": "Le nom est désormais réservé pour votre projet."
    }
  },
  "create": {
    "title": "إنشاء شركة",
    "subtitle": "أطلق هيكلك بدقة مؤسساتية.",
    "steps": {
      "founder": "المؤسس",
      "structure": "الهيكل",
      "review": "المراجعة"
    },
    "buttons": {
      "next": "الخطوة التالية",
      "back": "رجوع",
      "submit": "إرسال الطلب"
    }
  },
  "statutes": {
    "title": "توليد القانون الأساسي الرقمي",
    "subtitle": "قانون أساسي معتمد من LegalEngine",
    "sections": {
      "social_object": "الغرض الاجتماعي",
      "share_capital": "رأس المال الاجتماعي",
      "duration": "المدة",
      "headquarters": "المقر الاجتماعي",
      "governance": "الحوكمة",
      "fiscal_year": "السنة المالية",
      "liquidation": "التصفية",
      "partners": "الشركاء والمساهمات"
    },
    "actions": {
      "download_pdf": "تحميل القانون الأساسي (PDF)",
      "edit": "تعديل البيانات",
      "validate": "التصديق لدى الموثق"
    },
    "metadata": {
      "jurisdiction": "الاختصاص القضائي",
      "framework": "الإطار القانوني",
      "algeria": "الجزائر",
      "commercial_code": "القانون التجاري 2024",
      "certified_by": "معتمد من شريكاتي GSD"
    }
  },
  "statutes_generator": {
    "title": "مولد القوانين الأساسية",
    "subtitle": "تخصيص وتوليد القوانين الأساسية لشركتك بلمسة واحدة.",
    "sections": {
      "structure": "الهيكل والهوية",
      "governance": "الحوكمة والإدارة",
      "capital": "رأس المال والشركاء",
      "compliance": "تدقيق الامتثال"
    },
    "fields": {
      "legal_form": "الشكل القانوني المقترح",
      "company_name": "اسم الشركة",
      "company_name_placeholder": "مثال: SARL ALPHA DZ",
      "activity": "الغرض الاجتماعي (النشاط الرئيسي)",
      "activity_placeholder": "صف النشاط الاقتصادي الرئيسي...",
      "address": "المقر الاجتماعي (العنوان الكامل)",
      "address_placeholder": "العنوان، المدينة، الولاية",
      "manager_name": "اسم المسير / المدير",
      "manager_placeholder": "الاسم واللقب الكامل...",
      "powers": "صلاحيات المسير",
      "powers_standard": "أوسع السلطات للتصرف باسم الشركة.",
      "powers_limited": "سلطات محدودة بأعمال التسيير العادية.",
      "powers_secured": "التوقيع المشترك إلزامي لأي عمل يتجاوز 500,000 دج.",
      "powers_standard_text": "أوسع الصلاحيات للتصرف باسم الشركة.",
      "powers_limited_text": "صلاحيات محدودة بأعمال الإدارة العادية.",
      "powers_secured_text": "التوقيع المشترك مطلوب لأي عمل > 500,000 دج.",
      "capital": "رأس المال الاجتماعي (دج)",
      "share_value": "قيمة الحصة / السهم (دج)",
      "partners_list": "قائمة الشركاء / المساهمين",
      "partner_badge": "شريك رقم {{index}}",
      "partner_name_placeholder": "اسم الشريك...",
      "partner_id_placeholder": "رقم الهوية / جواز السفر...",
      "risk_level": "مستوى المخاطر",
      "risk_prudent": "حذر",
      "risk_moderate": "متوسط",
      "risk_aggressive": "جريء",
      "threshold": "عتبة الرقابة",
      "spas_options": "إعدادات متقدمة (SPAS)"
    },
    "defaults": {
      "activity": "التجارة والخدمات",
      "role": "شريك",
      "category_founder": "مؤسس",
      "role_manager": "مسير"
    },
    "validations": {
      "compliant": "البيانات متوافقة مع القانون",
      "correction": "تصحيحات مطلوبة",
      "success_msg": "كل العناصر صحيحة. يمكنك المتابعة.",
      "name_required": "اسم الشركة مطلوب",
      "name_short": "الاسم قصير جداً بالنسبة لـ CNRC",
      "capital_zero": "يجب أن يكون رأس المال أكبر من 0",
      "shares_mismatch": "توزيع غير متسق: {{total}}% (يجب أن يكون 100%)",
      "eurl_unipersonal": "EURL هي مؤسسة لشخص واحد حصراً",
      "spa_capital_min": "الحد الأدنى لرأس المال لشركة مساهمة هو 1,000,000 دج",
      "spa_partners_min": "تتطلب الشركة المساهمة 7 مساهمين على الأقل",
      "sarl_partners_max": "لا يمكن لشركة SARL تجاوز 50 شريكاً",
      "manager_required": "الممثل القانوني (مسير/رئيس) مطلوب"
    },
    "buttons": {
      "reset": "إعادة تعيين",
      "generate": "توليد الوثيقة",
      "balance": "توزيع تلقائي",
      "add_partner": "إضافة شريك"
    },
    "toasts": {
      "processing_title": "جاري المعالجة",
      "processing_msg": "توليد القانون الأساسي الرسمي...",
      "error_title": "خطأ في التوليد",
      "error_msg": "حدث خطأ أثناء معالجة البيانات.",
      "success_title": "تم توليد البيانات",
      "success_msg": "تم إعداد مسودة القانون الأساسي بنجاح."
    },
    "actions": {
      "reset": "إعادة ضبط",
      "generate": "توليد الوثائق"
    },
    "company_data": "بيانات الشركة",
    "legal_form_label": "الشكل القانوني",
    "company_name_label": "اسم الشركة",
    "company_name_placeholder": "أدخل الاسم التجاري...",
    "activity_label": "النشاط الرئيسي (الموضوع الاجتماعي)",
    "activity_placeholder": "صف نشاط الشركة بالتفصيل...",
    "address_label": "المقر الاجتماعي",
    "address_placeholder": "العنوان الكامل والولاية...",
    "validation": {
      "required": "هذا الحقل مطلوب",
      "shares_sum": "مجموع الحصص يجب أن يكون 100% (الحالي: {{total}}%)",
      "min_capital": "الحد الأدنى لرأس المال لهذا الشكل هو {{min}} دج"
    },
    "setup": "المادة"
  },
  "compliance": {
    "title": "وحدة الامتثال",
    "subtitle": "مراقبة في الوقت الفعلي لوضعك القانوني واللوائحي.",
    "status": {
      "title": "حالة الامتثال",
      "compliant": "ممتثل",
      "non_compliant": "غير ممتثل",
      "at_risk": "في خطر",
      "risk_negligible": "ضئيل",
      "risk_critical": "حرج",
      "risk_moderate": "متوسط",
      "risk_level": "مستوى الخطر: {{level}}",
      "access_registry": "الدخول إلى السجل",
      "health_index": "مؤشر الصحة",
      "active_alerts": "التنبيهات النشطة",
      "immediate_attention": "انتباه فوري مطلوب",
      "next_deadlines": "المواعيد النهائية القادمة",
      "current_cycle": "الدورة الحالية"
    },
    "registry": {
      "title": "سجل الالتزامات",
      "filter_placeholder": "تصفية الالتزامات...",
      "priority": "الأولوية",
      "deadline": "الموعد النهائي",
      "penal_risk": "خطر جنائي",
      "action_start": "بدء",
      "actionLabel": "بدء"
    },
    "tasks": {
      "title": "الالتزام",
      "social_accounts": {
        "title": "إيداع الحسابات الاجتماعية",
        "desc": "إيداع سنوي إلزامي للحسابات لدى المركز الوطني للسجل التجاري قبل 30 جوان.",
        "basis": "المادة 717 من القانون التجاري",
        "penalty": "غرامات وتجميد السجل التجاري"
      },
      "g50": {
        "title": "تصريح G50 (شهري)",
        "desc": "التصريح ودفع الضرائب (TAP, TVA, IRG, IBS).",
        "basis": "قانون الضرائب المباشرة",
        "penalty": "عقوبات التأخير في الدفع (10-25%)"
      },
      "bank_dossier": {
        "title": "تحديث الملف البنكي",
        "desc": "تجديد وثائق اعرف عميلك (KYC) لدى بنكك.",
        "basis": "نظام 02-11 لبنك الجزائر",
        "penalty": "تجميد العمليات البنكية"
      },
      "ago": {
        "title": "الجمعية العامة العادية السنوية (AGO)",
        "desc": "الجمعية العامة العادية للمصادقة على الحسابات.",
        "basis": "المادة 675 من القانون التجاري",
        "penalty": "بطلان القرارات الاجتماعية"
      },
      "das": {
        "title": "تصريح DAS (سنوي)",
        "desc": "التصريح السنوي للأجور والاشتراكات الاجتماعية.",
        "basis": "القانون 83-14 المتعلق بالضمان الاجتماعي",
        "penalty": "غرامات عن كل موظف غير مصرح به"
      }
    },
    "form": {
      "title": "العنوان",
      "description": "الوصف",
      "category": "الفئة",
      "placeholder_title": "مثال: اشتراكات كاصنوص",
      "placeholder_desc": "أدخل تفاصيل الالتزام..."
    },
    "priorities": {
      "CRITIQUE": "حرج",
      "HAUTE": "عالية",
      "MOYENNE": "متوسطة",
      "FAIBLE": "منخفضة"
    },
    "categories": {
      "JURIDIQUE": "قانوني",
      "FISCAL": "جبائي",
      "SOCIAL": "اجتماعي",
      "ADMIN": "إداري"
    },
    "audit": {
      "title": "التتبع والتدقيق",
      "validated_event": "حدث مصادق عليه",
      "agent": "الوكيل: {{user}}",
      "id": "مرجع التدقيق",
      "empty": "لا يوجد سجل تدقيق متاح",
      "download": "تحميل التقرير",
      "system_init": "تم تهيئة نظام الامتثال",
      "baseline_scan": "اكتمل المسح اللوائحي الأساسي"
    },
    "toasts": {
      "admin": "مسؤول النظام",
      "resolved_title": "تمت تسوية الالتزام",
      "resolved_msg": "تم وضع علامة مكتمل على الالتزام. مرجع: {{ref}}",
      "added": "تم إضافة التزام جديد إلى السجل",
      "log_msg": "تم تنفيذ الإجراء: {{title}}"
    },
    "intelligence": {
      "title": "الذكاء اللوائحي",
      "real_time": "الوقت الفعلي",
      "break_point": "تم اكتشاف نقطة انقطاع",
      "break_point_desc": "درجة الامتثال الخاصة بك <1>أقل من 60%</1>. من الضروري تسوية <3>الملف البنكي</3> فوراً.",
      "start_regularization": "بدء التسوية",
      "secure_perimeter": "محيط آمن",
      "secure_desc": "لم يتم اكتشاف أي شذوذ حرج. هيكلك ممتثل تماماً للوائح الحالية."
    },
    "nav": {
      "overview": "نظرة عامة",
      "registry": "السجل",
      "intelligence": "الذكاء"
    }
  },
  "statutes_result": {
    "title": "توليد القانون الأساسي",
    "subtitle": "ملخص والمستندات الرسمية جاهزة للتوقيع.",
    "actions": {
      "print": "طباعة",
      "download_pdf": "تحميل PDF",
      "share": "مشاركة",
      "archive": "أرشفة",
      "export_excel": "تصدير Excel",
      "advanced_options": "خيارات متقدمة",
      "view_docs": "اطلاع على الوثائق"
    },
    "status": {
      "document_state": "حالة المستند",
      "cnrc_compliant": "متوافق مع السجل التجاري 2024",
      "automated": "توليد تلقائي",
      "accuracy": "درجة الدقة القانونية",
      "legal_notice": "ملاحظة قانونية",
      "legal_notice_text": "يتم توليد هذه القوانين الأساسية ديناميكيًا بناءً على مدخلاتك. يجب أن يتم التحقق منها من قبل موثق معتمد لتكون نافذة.",
      "legal_notice_warning": "تمثل هذه الوثيقة مسودة معتمدة للقوانين الأساسية. يجب تصديقها لدى موثق معتمد لتكتسب كامل القوة القانونية.",
      "end_of_document": "نهاية مستند التأسيس"
    },
    "signature": {
      "mention_approved": "قرئ وصودق عليه",
      "partner_initials": "توقيع الشركاء بالأحرف الأولى",
      "company_seal": "ختم الشركة",
      "manager_signature": "توقيع المسير"
    },
    "placeholders": {
      "name": "[التسمية الاجتماعية]",
      "activity": "[الموضوع الاجتماعي المفصل]",
      "address": "[المقر الاجتماعي الكامل]",
      "representative": "[اسم المسير]"
    },
    "initial_data": {
      "activity": "الموضوع الاجتماعي",
      "complexity": "متوسط",
      "automation": "متقدم",
      "type": "الشكل",
      "capital": "رأس المال",
      "partners": "الشركاء",
      "complexity_label": "التعقيد",
      "automation_label": "الأتمتة"
    },
    "articles": {
      "standard": {
        "art1_title": "الشكل القانوني",
        "art1_content": "تأسست الشركة في شكل {{form}}، وفقاً لأحكام القانون التجاري الجزائري.",
        "art2_title": "التسمية",
        "art2_content": "التسمية الاجتماعية للشركة هي: {{name}}. ويتبعها أو يسبقها ذكر {{form}}.",
        "art3_title": "المقر الاجتماعي",
        "art3_content": "حدد المقر الاجتماعي في: {{address}}. ويمكن نقله بمجرد قرار من التسيير.",
        "art4_title": "الموضوع الاجتماعي",
        "art4_content": "موضوع الشركة هو: {{activity}}، وبشكل عام كل العمليات المرتبطة بهذا الموضوع.",
        "art5_title": "رأس المال الاجتماعي",
        "art5_content": "حدد رأس المال الاجتماعي بـ {{capital}} دج. وهو مقسم إلى {{count}} حصص اجتماعية بقيمة {{value}} دج لكل منها.",
        "art6_title": "التسيير",
        "art6_content": "يدير الشركة {{manager}}. {{powers}}",
        "art7_title": "السنة المالية",
        "art7_content": "تبدأ السنة المالية في أول جانفي وتنتهي في 31 ديسمبر من كل عام.",
        "art8_title": "القرارات الجماعية",
        "art8_content": "تتخذ قرارات الشركاء في جمعية عامة أو عن طريق استشارة كتابية.",
        "art9_title": "توزيع الأرباح",
        "art9_content": "يوزع الربح القابل للتوزيع بين الشركاء بنسبة مساهماتهم.",
        "art10_title": "الحل",
        "art10_content": "يمكن النطق بالحل المسبق للشركة بقرار من الشركاء.",
        "art11_title": "المنازعات",
        "art11_content": "تخضع جميع المنازعات المتعلقة بالشؤون الاجتماعية للمحاكم المختصة."
      },
      "spas": {
        "art1_title": "شكل شركة المساهمة البسيطة",
        "art1_content": "شركة {{name}} هي شركة مساهمة بسيطة (SPAS)، تخضع للقوانين المعمول بها.",
        "art2_title": "موضوع الشركة",
        "art2_content": "الموضوع الاجتماعي للشركة هو: {{activity}}.",
        "art3_title": "رأس المال والأسهم",
        "art3_content": "رأس المال هو {{capital}} دج، يتكون من أسهم بقيمة {{value}} دج.",
        "art4_title": "المساهمون",
        "art4_content": "المساهمون المؤسسون هم: {{partners}}.",
        "art5_title": "الرئاسة",
        "art5_content": "يمثل الشركة رئيس يعين وفقاً للشروط المنصوص عليها في هذا القانون الأساسي.",
        "art6_title": "تعقيد الحوكمة",
        "art6_content": "هيكل الحوكمة من نوع {{complexity}}.",
        "art7_title": "عتبات الرقابة",
        "art7_content": "يتم تفعيل رقابة محددة لكل مبلغ يتجاوز {{threshold}} دج.",
        "art8_title": "إدارة المخاطر",
        "art8_content": "تم تحديد مستوى المخاطر التشغيلية على أنه {{risk}}.",
        "art9_title": "تنازل عن الأسهم",
        "art9_content": "يخضع كل تنازل عن الأسهم للموافقة المسبقة من جماعة المساهمين.",
        "art10_title": "جمعيات المساهمين",
        "art10_content": "يتمتع المساهمون بحق تصويت يتناسب مع عدد الأسهم التي يمتلكونها.",
        "art11_title": "بنود عدم التنازل",
        "art11_content": "يمكن أن تنص القوانين الأساسية على عدم قابلية الأسهم للتنازل لمدة لا تتجاوز عشر سنوات.",
        "art12_title": "أحكام متنوعة",
        "art12_content": "تتم تسوية جميع الأحكام الأخرى وفقاً للقانون التجاري."
      }
    },
    "pdf": {
      "institutional_header": "الجمهورية الجزائرية الديمقراطية الشعبية",
      "ministry_header": "وزارة العدل - المديرية العامة للسجل التجاري",
      "main_title": "القانون الأساسي",
      "generation_date": "تاريخ التوليد",
      "ref": "مرجع التدقيق",
      "filename_prefix": "Statutes_",
      "currency": "دج",
      "footer_text": "مستند معتمد من قبل Charikaty Legal Sentinel - التوافق مع القانون التجاري 2024",
      "company_name": "التسمية الاجتماعية",
      "legal_form": "الشكل القانوني",
      "headquarters": "المقر الاجتماعي",
      "capital": "رأس المال الاجتماعي",
      "partners_table": {
        "name": "اسم الشريك",
        "identity": "بطاقة الهوية",
        "shares": "الحصص",
        "contribution": "المساهمة (دج)"
      }
    },
    "excel": {
      "filename": "تدقيق_القوانين_{{name}}.xlsx",
      "sheet_name": "القوانين الأساسية",
      "headers": {
        "article": "مادة",
        "title": "العنوان",
        "content": "المحتوى"
      },
      "report_title": "تقرير الهيكل التأسيسي"
    },
    "toasts": {
      "archived_title": "تمت أرشفة المستند",
      "archived_msg": "تم حفظ المستند في خزنتك الرقمية.",
      "shared_title": "تم نسخ الرابط",
      "shared_msg": "تم نسخ رابط هذا المستند إلى الحافظة.",
      "pdf_ready_title": "ملف PDF جاهز",
      "pdf_ready_msg": "تم توليد القانون الأساسي الخاص بك وهو جاهز للتحميل.",
      "export_ready_title": "تم التصدير بنجاح",
      "export_ready_msg": "تم تصدير البيانات إلى ملف Excel.",
      "error_gen": "خطأ أثناء توليد ملف PDF.",
      "error_export": "خطأ أثناء تصدير Excel.",
      "error_archive": "خطأ أثناء الأرشفة.",
      "error_no_data": "لم يتم العثور على بيانات القانون الأساسي."
    }
  },
  "documentation_modal": {
    "title": "الوثائق القانونية",
    "subtitle": "دليل الامتثال الجزائري v2024.1",
    "search_placeholder": "البحث عن مادة...",
    "warning_title": "تحذير",
    "warning_text": "يتم توفير هذه المعلومات للإرشاد فقط ولا تعوض نصيحة خبير قانوني معتمد.",
    "help_title": "هل تحتاج للمساعدة؟",
    "help_text": "اتصل بالدعم القانوني المتخصص لدينا.",
    "open_ticket": "فتح تذكرة",
    "certified": "معتمد من شريكاتي Legal",
    "download_guide": "تحميل دليل PDF",
    "sections": {
      "legal_framework": {
        "title": "الإطار القانوني الجزائري",
        "items": {
          "commerce": "القانون التجاري: المواد 544 وما يليها تحدد الأشكال الاجتماعية.",
          "decree": "المرسوم التنفيذي رقم 97-40: المتعلق بمعايير تأسيس الشركات.",
          "startup": "القانون رقم 22-09: المتعلق بالمقاول الذاتي والمؤسسات الناشئة (SAS)."
        }
      },
      "notary_role": {
        "title": "دور الموثق",
        "items": {
          "auth": "التوثيق: يجب إبرام جميع العقود التأسيسية أمام موثق.",
          "deposit": "الإيداع القانوني: يضمن الموثق إيداع القوانين الأساسية لدى CNRC.",
          "publicity": "الإشهار القانوني: إدراج إلزامي في النشرة الرسمية للإعلانات القانونية (BOAL)."
        }
      },
      "cnrc_steps": {
        "title": "خطوات السجل التجاري (CNRC)",
        "items": {
          "name": "التسمية: الحصول على الشهادة السلبية.",
          "registration": "التسجيل: إيداع الملف الكامل لدى السجل التجاري.",
          "card": "البطاقة المغناطيسية: تسليم المستخرج النهائي للسجل التجاري."
        }
      }
    }
  },
  "creation": {
    "title": "إنشاء شركة",
    "description": "سير عمل للتسجيل وتأسيس كيانات قانونية جديدة.",
    "pipeline": "خط أنابيب المشاريع",
    "immatriculation": "التسجيل",
    "expert_advice": {
      "title": "نصيحة خبير",
      "text": "\"يتم التسجيل رسمياً بعد 48 ساعة من التوقيع الموثق.\""
    },
    "steps": {
      "identity": {
        "title": "الهوية",
        "desc": "الاسم والنوع"
      },
      "headquarters": {
        "title": "المقر",
        "desc": "الموقع"
      },
      "governance": {
        "title": "الحوكمة",
        "desc": "المساهمة"
      },
      "validation": {
        "title": "التحقق",
        "desc": "التدقيق القانوني"
      }
    },
    "step1": {
      "title": "الهوية القانونية",
      "subtitle": "حدد الشخصية المعنوية لشركتك.",
      "name_label": "الاسم التجاري",
      "name_reserved": "الاسم المحجوز",
      "name_placeholder": "مثال: ALGERIA TECH HUB",
      "form_label": "الشكل القانوني",
      "common_hint": "(الأكثر شيوعاً)",
      "selected_via_simulator": "مختار عبر المحاكي",
      "sector_label": "القطاع القانوني",
      "sector_placeholder": "مثال: الخدمات الرقمية"
    },
    "step2": {
      "title": "المقر ورأس المال",
      "subtitle": "الواقع العقاري والاتساق المالي للمشروع.",
      "wilaya_label": "ولاية التسجيل",
      "address_label": "العنوان التفصيلي (محلي)",
      "address_placeholder": "رقم، شارع، حي، بلدية...",
      "address_hint": "يجب أن يتطابق مع عقد الإيجار (موثق أو عرفي).",
      "capital_label": "رأس المال (دج)",
      "min_legal": "الحد الأدنى القانوني",
      "capital_hint": "بالنسبة لـ <1>{{type}}</1>، يجب إثبات إيداع رأس المال بشهادة بنكية.",
      "capital_guarantee": "ضمان رأس المال",
      "capital_guarantee_desc": "يحدد رأس المال مسؤولية الشركاء في حدود مساهماتهم."
    },
    "step3": {
      "title": "الحوكمة",
      "subtitle": "هيكل رأس المال وتعيين المسيرين.",
      "new_associate": "+ شريك جديد",
      "associate_name": "اسم الشريك",
      "name_placeholder": "الاسم واللقب",
      "identity_label": "الهوية (NIN / جواز السفر)",
      "identity_placeholder": "رقم الهوية",
      "shares_label": "الأسهم (%)",
      "executive_role": "دور تنفيذي",
      "roles": {
        "gerant": "مسير رئيسي",
        "associe": "شريك بسيط",
        "dg": "مدير عام (DG)"
      },
      "cap_table_title": "تحليلات جدول المساهمين",
      "total_distributed": "إجمالي الموزع",
      "shares_warning": "يجب أن يكون إجمالي الأسهم مساوياً لـ 100% بدقة لتوقيع القانون الأساسي."
    },
    "step4": {
      "title": "التدقيق والتحقق",
      "subtitle": "التحقق النهائي قبل إصدار العقود القانونية.",
      "compliance_rate": "الامتثال",
      "summary": {
        "identity": "الهوية",
        "capital": "رأس المال",
        "capital_desc": "مساهمة كاملة",
        "governance": "المساهمة",
        "governance_desc": "الإدارة: {{manager}}"
      },
      "report_title": "تقرير Sentinel",
      "compliance_note": {
        "title": "ملاحظة الامتثال",
        "engine": "محرك Sentinel v2024.1",
        "description": "\"يتوافق التكوين المختار مع المواد 544 وما يليها من القانون التجاري الجزائري. سيكون التوقيع الإلكتروني متاحاً عند التحقق من سير العمل هذا.\""
      },
      "audit_summary": {
        "title": "التدقيق المؤسساتي",
        "health": "مؤشر الصحة القانونية",
        "hint": "يقيم هذا المؤشر الامتثال التنظيمي وحماية الأصول الشخصية."
      },
      "legal_note": {
        "title": "ملاحظة قانونية",
        "desc": "ستتبع القوانين الأساسية المنشأة بدقة أحكام القانون التجاري الجزائري 2024."
      },
      "status": {
        "in_progress": "التدقيق جارٍ",
        "hint": "يتم إجراء التدقيق المؤسساتي تلقائياً في خطوة التحقق."
      }
    },
    "footer": {
      "previous": "السابق",
      "next": "التالي",
      "submit": "إنهاء الإنشاء",
      "progress": "تقدم المسار"
    },
    "audit_labels": {
      "denomination": "التسمية",
      "structure": "هيكل الشركاء",
      "capital": "رأس المال الاجتماعي",
      "distribution": "تناسب رأس المال",
      "ready_audit": "جاهز للتدقيق",
      "required": "مطلوب",
      "validated": "تم التحقق والحجز",
      "partners_ok": "{{count}} شركاء (حسناً)",
      "partners_range": "الأدنى: {{min}}، الأقصى: {{max}}",
      "capital_ok": "ممتثل للقانون",
      "capital_req": "مطلوب: {{min}} دج كحد أدنى",
      "distribution_ok": "توزيع متوازن",
      "distribution_fail": "الإجمالي: {{total}}%"
    }
  },
  "creation_result": {
    "title": "ملخص الإنشاء",
    "description": "تم التحقق من ملف التأسيس واعتماده من قبل Charikaty Legal Sentinel.",
    "success_header": "تم بدء العملية",
    "entity_ready": "كيانك القانوني <1>{{name}}</1> جاهز للتسجيل.",
    "certified_dossier": "ملف معتمد",
    "default_activity": "خدمات عامة",
    "country": "الجزائر",
    "legal_form_label": "الشكل القانوني",
    "capital_label": "رأس المال الاجتماعي",
    "associates_table_title": "جدول الشركاء",
    "members_count": "{{count}} أعضاء",
    "compliance_title": "الامتثال القانوني",
    "audit_ref": "مرجع التدقيق",
    "cnrc_verification": "تحقق CNRC",
    "certified": "معتمد",
    "wilaya": "الولاية",
    "complete_dossier": "ملف كامل",
    "complete_dossier_desc": "تم التحقق من جميع العناصر المطلوبة للتسجيل.",
    "next_steps_title": "الخطوات القادمة",
    "steps": {
      "statutes": {
        "title": "إنشاء القانون الأساسي",
        "desc": "صياغة تلقائية للقوانين التأسيسية."
      },
      "notary": {
        "title": "التوقيع الموثق",
        "desc": "موعد لدى الموثق (مركز الجزائر)."
      },
      "cnrc": {
        "title": "تسجيل CNRC",
        "desc": "الحصول على السجل التجاري النهائي."
      }
    },
    "legal_note_title": "ملاحظة قانونية",
    "legal_note_desc": "هذا الملخص يمثل تدقيقاً ما قبل التسجيل. ستتوافق القوانين الأساسية المنشأة مع القانون التجاري الجزائري v2024.",
    "actions": {
      "modify": "تعديل",
      "pdf": "PDF",
      "generate": "إنشاء القانون الأساسي"
    }
  },
  "creation_success": {
    "title": "نجاح مؤسساتي",
    "subtitle": "تم توليد وتدقيق هيكلك القانوني بنجاح بواسطة محرك LegalEngine.",
    "badge": "معتمد من شريكاتي",
    "summary_title": "ملخص التأسيس",
    "company_name": "التسمية",
    "legal_form": "الشكل القانوني",
    "capital_label": "رأس المال الاجتماعي",
    "associates_table_title": "جدول الشركاء",
    "members_count": "{{count}} أعضاء",
    "compliance_title": "الامتثال القانوني",
    "audit_ref": "مرجع التدقيق",
    "cnrc_verification": "التحقق من CNRC",
    "certified": "معتمد",
    "wilaya": "الولاية",
    "complete_dossier": "الملف مكتمل",
    "complete_dossier_desc": "تم التحقق من جميع العناصر المطلوبة للتسجيل.",
    "next_steps_title": "الخطوات القادمة",
    "steps": {
      "statutes": {
        "title": "توليد القانون الأساسي",
        "desc": "الصياغة الآلية للقوانين الأساسية التأسيسية."
      },
      "notary": {
        "title": "التوقيع الموثق",
        "desc": "موعد لدى الموثق (الجزائر الوسطى)."
      },
      "cnrc": {
        "title": "التسجيل في CNRC",
        "desc": "الحصول على السجل التجاري النهائي."
      }
    },
    "legal_note_title": "ملاحظة قانونية",
    "legal_note_desc": "هذا الملخص يشكل تدقيقاً لما قبل التسجيل. القوانين الأساسية المولدة ستكون متوافقة مع القانون التجاري الجزائري v2024.",
    "actions": {
      "modify": "تعديل",
      "pdf": "تحميل PDF",
      "generate": "توليد القانون الأساسي"
    }
  }
}